import axios from 'axios';


    

const service = axios.create();


service.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem('token')
    if (token) {
      config.headers['X-Access-Token'] = token;// 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export {
  service as axios
  }
